/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-form-field[_ngcontent-%COMP%]{font:400 16px/1.125 Roboto,\"Helvetica Neue\",sans-serif}.settings[_ngcontent-%COMP%]{padding:24px}@media screen and (max-width:1279px){.settings[_ngcontent-%COMP%]{padding:16px}}.settings[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{font-size:20px;margin-top:24px;margin-bottom:12px}.settings[_ngcontent-%COMP%]   .title.no-margin-top[_ngcontent-%COMP%]{margin-top:0}.settings[_ngcontent-%COMP%]   .layout-radio-group[_ngcontent-%COMP%]   .layout-option-image[_ngcontent-%COMP%]{width:150px;height:100px}"];
export { styles as styles };
